import { useState } from "react";
import { Box, Stack } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";

import { useSSAuth } from "../../hooks/useSSAuth";
import { createState } from "src/utils/create_zustand_store";

import {
  LastNameTextField,
  FirstNameTextField,
} from "src/components/base/components/FormComponents/FormComponents";
import { DynamicModal } from "src/components/base/components/DynamicModal";
import { PhoneNumberTextField } from "src/components/base/components/FormComponents/PhoneNumberTextField";

import type { TUpdateProfile } from "src/shared/types/api.types";

export const useUpdateProfileModal = createState({
  isOpen: false,
  onConfirm: () => Promise<{ session: string }>,
});

export function UpdateProfileModal() {
  const modalState = useUpdateProfileModal();
  const formMethods = useForm<TUpdateProfile>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const { user, updateProfile } = useSSAuth();

  function onClose() {
    modalState.reset();
  }

  async function onSubmit(data: TUpdateProfile) {
    setIsSubmitting(true);
    await updateProfile(data);
    setIsSubmitting(false);
    onClose();
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <DynamicModal
          isOpen={modalState.isOpen}
          title="Update Information"
          description={
            <Stack spacing={2}>
              <FirstNameTextField defaultValue={user?.firstName} />
              <LastNameTextField defaultValue={user?.lastName} />
              <PhoneNumberTextField defaultValue={user?.phoneNumber} />
            </Stack>
          }
          onClose={onClose}
          slot={{
            primaryButton: {
              label: "Confirm",
              isLoading: isSubmitting,
              isDisabled: isSubmitting,
              onClick: () => onSubmit(formMethods.getValues()),
            },
            secondaryButton: {
              label: "Cancel",
              onClick: () => onClose(),
            },
          }}
        />
      </form>
    </FormProvider>
  );
}
